import React from 'react'
import { Form } from 'react-bootstrap'

export default ({ label, value, name, to, onChange, checked, disabled, required, className }) => {
  return (
    <Form.Check
      custom
      inline
      className={`text-grey large ${className}`}
      type={"radio"}
      id={`${name}_${value}`}
      label={label}
      name={name}
      checked={checked}
      disabled={disabled}
      required={required}
      onChange={() => onChange(name, value)}
    />
  )
}